module.exports = __webpack_public_path__ + "static/media/green-wallet.396f1da8.svg";